import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_MANPOWER_SUCCESS,
  FETCH_MANPOWER_SUCCESS,
  GET_MANPOWER_FROM_JOB_ALLOCATION,
  GET_MANPOWER_SUCCESS,
  SAVE_MANPOWER_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import {getUser} from "./Auth";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_MANPOWER_SUCCESS,
    data,
    count
  };
};

export const getManpowerSuccess = ({data, count}) => {
  return {
    type: GET_MANPOWER_FROM_JOB_ALLOCATION,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_MANPOWER_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_MANPOWER_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_MANPOWER_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {manpower} = store.getState();
      const {query} = manpower;
      const response = await axios.get(`/manpower?${generateQueryString(query)}`);
      // console.log(response);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {manpower} = store.getState();
      const {query} = manpower;
      const response = await axios.get(`/manpower/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const searchManpower = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());
    try {
      const query = `searchString=${id}`;
      const response = await axios.get(`/manpower/search?${query}`);
      dispatch(fetchSuccess());
      dispatch(getManpowerSuccess(response));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};


export const createResource = (payload, redirect = true, module, subMaster = false, superMaster = false) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/manpower`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
      if(!redirect) {
        if(subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if(superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/manpower');
        dispatch(getResource());
      }
    } catch (error) {
      const errorMessage = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Unable to create manpower';
      message.error(errorMessage);
      dispatch(fetchError(errorMessage));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.put(`/manpower/${id}`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/manpower');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      const errorMessage = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Unable to update manpower';
      message.error(errorMessage);
      dispatch(fetchError(errorMessage));
    }
  }
};

export const addRfidCard = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.post(`/manpower/${id}/rfid-cards`, payload);
      dispatch(fetchSuccess());
      message.success('RFID registered successfully');
      dispatch(fetchResource(id));
      return response;
    } catch (error) {
      const errorMessage = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Unable to register RFID';
      message.error(errorMessage);
      dispatch(fetchError(errorMessage));
      throw error;
    }
  }
};

export const removeRfidCard = (id, rfidCardId) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/manpower/${id}/rfid-cards/${rfidCardId}`);
      dispatch(fetchSuccess());
      message.success('RFID registration removed');
      dispatch(fetchResource(id));
      return response;
    } catch (error) {
      const errorMessage = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Unable to remove RFID registration';
      message.error(errorMessage);
      dispatch(fetchError(errorMessage));
      throw error;
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/manpower/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/manpower/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
